import {removeSearchParamsByGridCode as removeEagGridSearchParams} from 'features/eag-grid';

import {CONFIGURATION_GRID_CODE} from './CONFIGURATION_GRID_CODE';
import type {ConfigurationPreset} from './getConfigurationPresetFilter';

type SetConfigurationPreset = (preset: ConfigurationPreset) => void;
type RemoveGridSearchParams = (gridCode: string) => void;

export function changeConfigurationPreset(
  preset: ConfigurationPreset,
  setPreset: SetConfigurationPreset,
  removeEagGridParams: RemoveGridSearchParams = removeEagGridSearchParams
) {
  removeEagGridParams(CONFIGURATION_GRID_CODE);
  setPreset(preset);
}
